@if (hasError) {
  <section>
    <div style="width: 100%;"><kendo-svg-icon [icon]="icons.exclamationCircleIcon"/></div>
    <h1>{{ 'attention'  | translate }}</h1>
    <h4>{{ 'bookingHandler.reservationError' | translate }}</h4>
  </section>
} @else {
  <div style="width: 100%;"><kendo-svg-icon [icon]="icons.checkOutlineIcon"/></div>
  <h1>{{ 'bookingHandler.reservationConfirm' | translate | replace: '[contractId]' : contractId }}</h1>
  <h4>{{ 'bookingHandler.mailConfirmSent' | translate }}</h4>
  <h4 [innerHTML]="'bookingHandler.printRentalConfirmation' | translate | replace: '[link]' : ('<a target=\'_blank\' href=' + pdfLink + '>' + ('bookingHandler.hereDownload' | translate) + '</a>')"></h4>
  <h4>{{ 'bookingHandler.greetings' | translate }}</h4>
  <h4>{{ 'bookingHandler.forQuestionsContactUs' | translate }}&nbsp;
    <a [href]="'mailto:order@papinsport.com?subject=' + mail.subject +  '&body=' + mail.body" target="_blank">order&#64;papinsport.com</a>
  </h4>
}
<app-spacer/>
<div class="buttons-container">
  @if (hasError) {
    <button type="button" kendoButton size="medium" themeColor="primary" (click)="back()">
      {{ 'back' | translate }}
    </button>
    <app-spacer/>
    <span>{{'bookingHandler.or' | translate}}</span>
    <app-spacer/>
  }
  <button type="button" kendoButton size="medium" themeColor="primary" fillMode="outline" (click)="resetForm()">
    {{ 'bookingHandler.startAgain' | translate }}
  </button>
</div>
